














































import {Vue, Component, Prop} from 'vue-property-decorator';
import ColumnItem from '@/components/common/grid/ColumnItem.vue';
import {PutGridLayoutsRequest, GridNameType} from 'supporter';

@Component({
  components: {ColumnItem}
})
export default class GridColumnsLayer extends Vue {
  @Prop() private showFlg!: boolean;
  private closePop() {
    this.$emit('update:showFlg', false);
  }

  @Prop() private columnsOrder!: any;
  @Prop() private defaultColumnsOrder!: any;
  @Prop() private disabledCnt!: number;
  @Prop() private gridName!: string;

  private showColumnsOrder: any = [];

  private get checkedAll() {
    return this.showColumnsOrder.every((item: any) => item.checked);
  }

  private checkAll() {
    if (this.checkedAll) {
      this.showColumnsOrder.forEach((column: any) => {
        if (!column.disabled) {
          column.checked = false;
        }
      });
    } else {
      this.showColumnsOrder.forEach((column: any) => (column.checked = true));
    }
  }

  private checkedExposure() {
    let checkedList = this.showColumnsOrder.filter((item: any) => item.checked && !item.disabled);
    if (checkedList.length === 0) {
      alert(this.$t('GRID_LAYER_NOT_SELECTED_MSG'));
      return;
    }
    checkedList.forEach((item: any) => {
      item.visible = true;
    });
  }
  private checkedUnexposed() {
    let checkedList = this.showColumnsOrder.filter((item: any) => item.checked && !item.disabled);
    if (checkedList.length === 0) {
      alert(this.$t('GRID_LAYER_NOT_SELECTED_MSG'));
      return;
    }
    checkedList.forEach((item: any) => {
      item.visible = false;
    });
  }
  private allExposure() {
    this.showColumnsOrder.forEach((item: any) => {
      if (!item.disabled) {
        item.visible = true;
      }
    });
  }
  private allUnexposed() {
    this.showColumnsOrder.forEach((item: any) => {
      if (!item.disabled) {
        item.visible = false;
      }
    });
  }

  private moveItem({type, idx}: any) {
    if ((idx === this.disabledCnt && type === 'up') || (idx === this.showColumnsOrder.length - 1 && type === 'down')) {
      return;
    }
    let newColumnsOrder: any = [];
    if (type === 'up') {
      for (let i = 1; i < this.showColumnsOrder.length; i++) {
        if (i < idx) {
          newColumnsOrder.push(this.showColumnsOrder[i - 1]);
        } else if (i === idx) {
          newColumnsOrder.push(this.showColumnsOrder[i]);
          newColumnsOrder.push(this.showColumnsOrder[i - 1]);
        } else {
          newColumnsOrder.push(this.showColumnsOrder[i]);
        }
      }
    } else {
      for (let i = 0; i < this.showColumnsOrder.length - 1; i++) {
        if (i < idx) {
          newColumnsOrder.push(this.showColumnsOrder[i]);
        } else if (i === idx) {
          newColumnsOrder.push(this.showColumnsOrder[i + 1]);
          newColumnsOrder.push(this.showColumnsOrder[i]);
        } else {
          newColumnsOrder.push(this.showColumnsOrder[i + 1]);
        }
      }
    }
    this.showColumnsOrder = newColumnsOrder.map((item: any, idx: number) => {
      let tempItem = JSON.parse(JSON.stringify(item));
      tempItem.displayOrder = idx + 1;
      return tempItem;
    });
  }

  private async save() {
    let allUnexposedFlg = this.showColumnsOrder.every((column: any) => !column.visible);
    if (allUnexposedFlg) {
      alert(this.$t('GRID_LAYER_ALL_UNEXPOSED_MSG'));
      return;
    }
    let request: PutGridLayoutsRequest = {
      data: {
        gridName: this.gridName as GridNameType,
        columns: this.showColumnsOrder.map((column: any) => {
          return {
            columnName: column.columnName,
            displayOrder: column.displayOrder,
            visible: column.visible
          };
        })
      }
    };
    await this.$api.putGridLayouts(request);
    alert(this.$t('GRID_LAYER_SAVE_MSG'));
    this.closePop();
    this.$router.go(0);
  }

  private reset() {
    this.showColumnsOrder = this.defaultColumnsOrder.map((column: any, idx: number) => {
      return {
        columnName: column.columnName,
        displayOrder: column.displayOrder,
        visible: column.visible,
        showName: column.showName.replace('<br>', ''),
        disabled: idx < this.disabledCnt,
        checked: idx < this.disabledCnt
      };
    });
  }

  private async created() {
    this.showColumnsOrder = this.columnsOrder.map((column: any, idx: number) => {
      return {
        columnName: column.columnName,
        displayOrder: column.displayOrder,
        visible: column.visible,
        showName: column.showName.replace('<br>', ''),
        disabled: idx < this.disabledCnt,
        checked: idx < this.disabledCnt
      };
    });
  }
}
